namespace Matrix.Rebalancer {
    export interface OverlayAccountForm {
        AccountCode: FormatServiceLookupEditor;
        OverlayAccountCode: FormatServiceLookupEditor;
        OwnershipWeight: Serenity.DecimalEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class OverlayAccountForm extends Serenity.PrefixedContext {
        static formKey = 'Rebalancer.OverlayAccount';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OverlayAccountForm.init)  {
                OverlayAccountForm.init = true;

                var s = Serenity;
                var w0 = FormatServiceLookupEditor;
                var w1 = s.DecimalEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(OverlayAccountForm, [
                    'AccountCode', w0,
                    'OverlayAccountCode', w0,
                    'OwnershipWeight', w1,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Version', w2
                ]);
            }
        }
    }
}
